app.directive('medicalProcedures', ['$stateParams', 'objectHelper', 'icdModel', 'userModel', 'applicationModel',
    'medicalProcedureModel', '$mdDialog',
    function($stateParams, objectHelper, icdModel, userModel, applicationModel, medicalProcedureModel, $mdDialog) {
        var definition = {
            restrict: 'E',
            replace: true,
            require: '^form',
            scope: {
                visitCard: '=',
                visit: '=',
                patient: '=',
                template: '=',
                extras: '='
            },
            templateUrl: 'edm/application/directive/medicalProcedures/template/medical-procedures.html',
            link: function($scope, element, attr, formCtrl) {
                $scope.form = formCtrl;
                $scope.favouriteIcd9List = [];
                $scope.medicalProcedureHistoryList = [];
                $scope.doctorId = userModel.getCurrentContextDoctorId();
                $scope.allowedTypes = ['medicalProcedure'];
                $scope.showPreviousIcons = (userModel && userModel.currentUser && userModel.currentUser.userType === 'DOCTOR');
                $scope.isPreview = ($scope.template && $scope.template.user.id != userModel.currentUser.id);

                if(_.isUndefined(attr.extras)) {
                    $scope.extras = true;
                }

                $scope.removeMedicalProcedure = function (medicalProcedure) {
                    if(!$scope.template) {
                        if($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED) {
                            if(medicalProcedure.id) {
                                var label = medicalProcedure.icd9.description;
                                var configPopup = {
                                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                                    controller: 'popupDeleteWithReasonController',
                                    controllerAs: 'deleteConfirmCtrl',
                                    skipHide: true,
                                    locals: {
                                        labels: label,
                                        item: medicalProcedure,
                                        userModel: userModel,
                                        $mdDialog: $mdDialog,
                                        message: 'T.MODULE.PATIENT.MEDICAL_PROCEDURE_DELETE_CONFIRMATION'
                                    }
                                };

                                $mdDialog.show(configPopup).then(function(data) {
                                    $scope.visitCard.medicalProcedures.forEach(function(m, idx) {
                                        if(m.id === data.id) {
                                            $scope.visitCard.medicalProcedures[idx] = angular.copy(data);
                                        }
                                    })
                                });

                            } else {
                                _.remove($scope.visitCard.medicalProcedures, function(element) {
                                    return element === medicalProcedure;
                                });
                            }
                        } else if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                            _.remove($scope.visitCard.medicalProcedures, function(element) {
                                return element === medicalProcedure;
                            });
                            medicalProcedureModel.delete(medicalProcedure.id);
                        }
                    } else {
                        _.remove($scope.template.medicalProcedures, function(element) {
                            return element === medicalProcedure;
                        });
                    }
                };

                if($scope.extras) {
                    $scope.toggleFavourite = function(icd9) {
                        if(!$scope.isICD9Favourite(icd9)) {
                            icdModel.addFavouriteIcd9($scope.doctorId, icd9).then(onAddFavouriteICD9Success);
                        } else {
                            icdModel.deleteFavouriteIcd9($scope.doctorId, icd9).then(onDeleteFavouriteICD9Success);
                        }
                    };

                    $scope.isICD9Favourite = function(icd9) {
                        return $scope.favouriteIcd9List.some(function(favouriteICD9) {
                            return favouriteICD9.icd9.id === icd9.id;
                        })
                    };
                }

                $scope.addICD9ToMedicalProcedures = function(icd9) {
                    var newMedicalProcedure = new MedicalProcedureVO();
                    newMedicalProcedure.icd9 = icd9;
                    newMedicalProcedure.date = new Date();
                    newMedicalProcedure.times = 1;
                    if(!$scope.template) {
                        newMedicalProcedure.patient = new PatientVO();
                        newMedicalProcedure.patient.id = $scope.patient.id;
                        newMedicalProcedure.visitCard = new VisitCardVO($scope.visitCard.id);
                        $scope.visitCard.medicalProcedures.push(newMedicalProcedure);
                        if($scope.isVisitInProgress()) {
                            medicalProcedureModel.save(newMedicalProcedure).then(function (medicalProcedure) {
                                newMedicalProcedure.id = medicalProcedure.id;
                            });
                        }
                    } else {
                        $scope.template.medicalProcedures.push(newMedicalProcedure);
                    }

                };

                /**
                 * for drag&drop feature
                 * @param event
                 * @param index
                 * @param item
                 */
                $scope.dropMedicalProcedure = function(event, index, item) {
                    return objectHelper.translateObject(item, MedicalProcedureVO);
                };

                $scope.$watch('newMedicalProcedure', function(newVal, oldVal) {
                    if(!_.isUndefined(newVal) && newVal != null) {
                        $scope.addICD9ToMedicalProcedures(newVal);
                        $scope.newMedicalProcedure = undefined;
                    }
                });

                if($scope.extras && userModel.currentUser.userType === 'DOCTOR') {
                    icdModel.getFavouriteIcd9List($scope.doctorId).then(onGetFavouriteICD9);
                    icdModel.getPatientMedicalProcedureHistory($scope.doctorId, $stateParams.patientId).then(onGetPatientMedicalProcedureHistory);
                }

                function onGetFavouriteICD9(data) {
                    $scope.favouriteIcd9List = data;
                }

                function onGetPatientMedicalProcedureHistory(data) {
                    $scope.medicalProcedureHistoryList = data;
                }

                function onAddFavouriteICD9Success () {
                    icdModel.getFavouriteIcd9List($scope.doctorId).then(onGetFavouriteICD9);
                }

                function onDeleteFavouriteICD9Success () {
                    icdModel.getFavouriteIcd9List($scope.doctorId).then(onGetFavouriteICD9);
                }

                $scope.getMedicalProcedures = function () {
                    return $scope.template ? $scope.template.medicalProcedures : $scope.visitCard.medicalProcedures.filter(function (medicalProcedure) {
                        return !medicalProcedure.deleted;
                    });
                };

                $scope.updateMedicalProcedure = function (medicalProcedure) {
                    if(!$scope.template && $scope.isVisitInProgress() && medicalProcedure.times) {
                        medicalProcedureModel.update(medicalProcedure)
                    }
                };

                $scope.isVisitInProgress = function () {
                    return $scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS;
                };
            }
        };

        return definition;
    }
]);